module.exports = __webpack_public_path__ + "img/imge14.6bf1e7d7.png";